import type { ApprovalConfig } from '../../../../common/utils/approvalInfo';
import { InformationMessageType } from '../../../../common-ui/information-message/informationMessageUtils';

export const resolveArrivalNotepadApprovalInfo = (
  arrivalNotepadApplied: boolean,
): ApprovalConfig | null => {
  if (arrivalNotepadApplied) {
    return {
      backgroundColor: null,
      descriptionText: "The unit is already on quay and the booking can't be updated.",
      headerText: '',
      type: InformationMessageType.RegularInfo,
    };
  }
  return null;
};
